import { useSupportModeStore } from "@/store/useSupportModeStore";

export const useSupportMode = () => {
  const session = useSupportModeStore((state) => state.session);
  const enterSupportMode = useSupportModeStore(
    (state) => state.enterSupportMode
  );
  const exitSupportMode = useSupportModeStore((state) => state.exitSupportMode);

  return { session, enterSupportMode, exitSupportMode };
};
